'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESOLVE_ATTACHMENTS = exports.RESOLVE_ATTACHMENTS = 'RESOLVE_ATTACHMENTS';


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/constants/resolvedAttachmentsActionTypes.js
// module id = 324
// module chunks = 2 3